// extracted by mini-css-extract-plugin
export var hotspotButton = "HotspotOverlayMarker-module--hotspotButton--3yEWE";
export var hotspotNumber = "HotspotOverlayMarker-module--hotspotNumber--2FE9O";
export var hotspotActive = "HotspotOverlayMarker-module--hotspotActive--8FYOM";